import wxApi from '@/utils/wx_api'
import { UserLog } from '@/_base/log'

import callConsultant from '@/common/mixins/callConsultant'

import { openChat } from '@/data/im'

export const navigateToChat = (id, options = {}) => {
    const { from, layout_id } = options
    UserLog.contactConsultant(id)
    openChat(id,{
        from: from || '',
        layout_id: layout_id || ''
    })
}

export default {
    mixins: [
        callConsultant
    ],
    methods: {
        setClipboardData (e) {
            const { weixin, id, building_id } = e.currentTarget.dataset
            wxApi.setClipboardData(weixin, () => {
                wx.showModal({
                    title: '复制成功',
                    content: '添加置业顾问时，请说明来自成都购房通',
                    showCancel: false
                })
            })
            UserLog.copyConsultant(id, building_id)
        },
        goViewer (e) {
            const { id } = e.currentTarget.dataset
            wx.navigateTo({
                url: `/consultants/headimgs/main?id=${id}`
            })
        },
        goChat (id) {
            UserLog.contactConsultant(id)
            openChat(id,{
                building_id: this.building_id || '',
                from: this.from || '',
                layout_id: this.layout_id || ''
            })                
        }
    }
}
